import React, { ReactNode, useContext } from 'react'
import MuiTooltip from '@material-ui/core/Tooltip'
import { makeStyles, Theme, withStyles } from '@material-ui/core/styles'
import { WHITE } from '../../theme'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import classnames from 'classnames'
import { ResponsiveContext } from '../../utils/context/responsiveContext'

const useStyles = makeStyles<Theme, { open: boolean }>(
	() => (
		{
			tooltipContainer: {
				position: 'absolute',
				zIndex: props => props.open ? 2000 : 1
			}
		}
	)
)

const CustomTooltip = withStyles(
	(theme) => (
		{
			popper: {
				top: '-10px !important',
				left: '-40px !important',
				pointerEvents: 'initial'
			},
			tooltip: {
				background: WHITE,
				color: theme.palette.blue.main,
				border: `1px solid ${theme.palette.blue.main}`,
				borderRadius: 10,
				paddingLeft: 25,
				paddingTop: 25
			},
			tooltipPlacementBottom: {
				marginTop: -25,
				paddingTop: 30
			}
		}
	)
)(MuiTooltip)

interface AcceptingProps {
	title: string | ReactNode,
	open: boolean,
	setOpen: (open: boolean) => void,
	tooltipContainerStyle?: string
}

type TooltipProps = AcceptingProps

const Tooltip: React.FC<TooltipProps> = (
	{
		title,
		children,
		open,
		setOpen,
		tooltipContainerStyle
	}
) => {
	const classes = useStyles({ open })
	const { isLargeScreen } = useContext(ResponsiveContext)

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<CustomTooltip
				title={title as string}
				onClick={() => setOpen(true)}
				placement={isLargeScreen ? 'right-start' : 'bottom'}
				open={open}
				PopperProps={{
					disablePortal: true
				}}
			>
				{React.createElement('span', { className: classnames(classes.tooltipContainer, tooltipContainerStyle) }, children)}
			</CustomTooltip>
		</ClickAwayListener>
	)
}

export default Tooltip
